import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  headerWrapper: {
    width: "calc(100% - 11px)",
    height: designTokens.spacing[12],
    borderRadius: designTokens.borderRadius.md,
    backgroundColor: designTokens.primary[900],
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: `${designTokens.spacing[2]} ${designTokens.spacing[4]}`,
    position: "sticky",
    top: "5px",
    zIndex: 1000,
    margin: "5px",
    boxSizing: "border-box",
    "::before": {
      content: '""',
      position: "absolute",
      top: "-1rem",
      left: 0,
      right: 0,
      height: "1rem",
      background: designTokens.neutral.white,
    },
  },
  logoWrapper: {
    paddingTop: designTokens.spacing[1],
  },
  logoImage: {
    maxHeight: "32px",
    width: "auto",
    objectFit: "contain" as const,
  },
  infoWrapper: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[6],
  },
  hintWrapper: {
    color: designTokens.neutral.white,
    paddingTop: designTokens.spacing[1],
  },
  hintButton: {
    minWidth: "unset",
    padding: 0,
    color: designTokens.neutral.white,
    "&:hover": {
      backgroundColor: "transparent",
      color: designTokens.neutral.white,
    },
  },
  hintIcon: {
    fontSize: designTokens.fontSize["2xl"],
    cursor: "pointer",
    "&:focus": {
      outline: "none",
    },
  },
  popoverContentWrapper: {
    width: "272px",
    height: "112px",
    padding: designTokens.spacing[1],
  },
  headerLink: {
    fontWeight: designTokens.fontWeight.medium,
    fontFamily: designTokens.fontFamily,
    color: designTokens.neutral[700],
    width: "100%",
    textDecorationLine: "underline",
    "&:hover": {
      color: designTokens.neutral[700],
      textDecorationLine: "underline",
    },
    "&:active": {
      color: designTokens.neutral[700],
      textDecorationLine: "underline",
    },
    "&:visited": {
      color: designTokens.neutral[700],
      textDecorationLine: "underline",
    },
  },
  versionWrapper: {
    display: "flex",
    justifyContent: "space-between",
    padding: "0px",
  },
  versionText: {
    paddingLeft: "13px",
    color: designTokens.neutral[700],
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.medium,
    fontFamily: designTokens.fontFamily,
  },
  popoverLinkWrapper: {
    display: "flex",
    gap: designTokens.spacing[2],
    alignItems: "center",
    padding: designTokens.spacing[2],
  },
  userInfoWrapper: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    cursor: "pointer",
  },
  userMenuWrapper: {
    color: designTokens.neutral.white,
  },
  userMenuTrigger: {
    fontSize: designTokens.fontSize.xl,
    cursor: "pointer",
  },
  avatar: {
    "& > span": {
      color: designTokens.neutral.white,
      backgroundColor: designTokens.accent[500],
    },
  },
  userMenuItem: {
    display: "flex",
    alignItems: "center",
  },
  menuAvatar: {
    marginRight: designTokens.spacing[3],
  },
  menuNameMain: {
    fontWeight: designTokens.fontWeight.semibold,
  },
  menuNameSecondary: {
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.normal,
    color: designTokens.neutral[500],
  },
});
